"use client";

import { cn } from "@/lib/utils";
import { useAppSelector } from "@/redux/store";

interface CollapsedViewProps {
  prompt: string;
  images: File[];
  onExpand: () => void;
  isGenerating?: boolean;
}

const CollapsedView: React.FC<CollapsedViewProps> = ({
  prompt,
  images,
  onExpand,
  isGenerating = false,
}) => {
  const showSignupModal = useAppSelector((state) => state.user.showSignupModal);

  const handleClick = (e: React.MouseEvent) => {
    if (window.getSelection()?.toString() || isGenerating || showSignupModal)
      return;
    onExpand();
  };

  const handleInputClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (!isGenerating && !showSignupModal) {
      onExpand();
    }
  };

  return (
    <div onClick={handleClick} id="container-1">
      <div className="tw:flex tw:items-center tw:gap-1.5 tw:bg-white tw:rounded-lg tw:py-1.5 tw:px-2 tw:border tw:border-border-color">
        {images.length > 0 && (
          <div className="tw:flex tw:items-center tw:gap-0.5 tw:flex-shrink-0">
            {images.slice(0, 3).map((image, index) => (
              <div
                key={`collapsed-preview-${index}`}
                className="tw:relative tw:w-8 tw:h-8 tw:rounded-sm tw:overflow-hidden tw:border tw:border-border-color"
              >
                <img
                  src={URL.createObjectURL(image)}
                  alt={`Upload ${index + 1}`}
                  className="tw:w-full tw:h-full tw:object-cover"
                />
              </div>
            ))}
            {images.length > 3 && (
              <div className="tw:flex tw:items-center tw:justify-center tw:w-8 tw:h-8 tw:rounded-sm tw:bg-black/4 tw:text-xs tw:font-medium tw:text-black/60">
                +{images.length - 3}
              </div>
            )}
          </div>
        )}
        <input
          type="text"
          placeholder={
            isGenerating ? "Generating..." : "What do you want to make?"
          }
          value={prompt}
          onClick={handleInputClick}
          className={cn(
            "tw:flex-1 tw:border-none tw:outline-none tw:bg-transparent tw:text-black/87 tw:read-only:cursor-pointer tw:disabled:text-[rgba(0,0,0,0.38)]",
            isGenerating && "tw:read-only:cursor-not-allowed"
          )}
          readOnly
          disabled={isGenerating}
        />
      </div>
    </div>
  );
};

export default CollapsedView;
